<template>
    <div class="input-group input-group-solid">
        <input type="number"
               class="form-control form-control-solid"
               style="min-width: 100px;"
               v-model="edge.value"
               min="0"
        >
        <div class="input-group-append">
            <select class="form-control form-control-solid text-center w-100px"
                    v-model="edge.unit">
                <option value="cm">cm</option>
                <option value="m">m</option>
                <option value="in">in</option>
                <option value="ft">ft</option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default() {
                return {
                    value: 0.0,
                    unit: 'cm'
                }
            }
        }
    },

    data() {
        return {
            edge: this.value
        }
    },

    watch: {
        edge: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit('input', newValue)
            }
        }
    }
}
</script>
